import { SolanaTransactionInfo } from "@glow/shared";
import classNames from "classnames";
import { DateTime, Duration } from "luxon";
import { TransactionCategoryIcon } from "./TransactionCategoryIcon";
import React from "react";

export const TransactionCategory = ({
  timestamp,
  title,
  icon,
  className,
}: {
  timestamp: string | null;
  title: string;
  icon: SolanaTransactionInfo.IconName;
  className?: string;
}) => {
  let date;

  if (timestamp) {
    const ts = DateTime.fromISO(timestamp);
    if (ts.diffNow() > Duration.fromObject({ weeks: -1 })) {
      date = ts.toLocaleString({
        weekday: "short",
        hour: "numeric",
        minute: "2-digit",
      });
    } else if (ts.year === DateTime.local().year) {
      date = ts.toLocaleString({
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      });
    } else {
      date = ts.toLocaleString({
        dateStyle: "medium",
        timeStyle: "short",
      });
    }
  }

  return (
    <div className={classNames("transaction-category", className)}>
      <div className="flex-center-center spread info">
        <div className="flex-center-center">
          <TransactionCategoryIcon type={icon} display="eyebrow" />

          <div className="ml-2">{title}</div>
        </div>
        <div>{date}</div>
      </div>

      <style jsx>{`
        .info {
          font-size: var(--font-size-xs);
          color: var(--tertiary-color);
        }
      `}</style>
    </div>
  );
};

export const TransactionCategoryLoading = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "transaction-category shimmer-container",
        className,
      )}
    >
      <div className="flex-center-center spread info mb-1">
        <div className="flex-center-center">
          <div className="rounded icon shimmer" />
          <div className="ml-2 title shimmer rounded" />
        </div>

        <div className="date shimmer rounded" />
      </div>

      <style jsx>{`
        .info {
          font-size: var(--font-size-xs);
          color: var(--tertiary-color);
        }

        .title,
        .date {
          height: 0.75rem;
        }

        .title {
          width: 6rem;
        }

        .icon {
          width: 1rem;
          height: 1rem;
        }

        .date {
          width: 3rem;
        }
      `}</style>
    </div>
  );
};
